<template>
  <v-row>
    <!-- Sidebar Filters -->
    <v-col cols="4" md="4" lg="2">
      <producto-filters
        v-on:updateFilters="setFilters"
        v-on:clearFilter="clearFilters"
        v-model="filters"
        :show-deposito-filter="hasMultipleDepositos"
        :user-depositos="userDepositos"
        :deposito-id-seleccionado="depositoIdSeleccionado"
      />
    </v-col>

    <!-- Table Content -->
    <v-col cols="8" md="8" lg="10" class="producto-list-table-col">
      <!-- Lista precios selector -->
      <div v-if="showListaPreciosSelector" class="lista-precios-row">
        <v-select
          v-model="listaPreciosId"
          :items="listasPrecios"
          item-text="nombre"
          item-value="id"
          outlined
          dense
          hide-details
          label="Lista de precios"
          prepend-inner-icon="mdi-format-list-numbered"
          @change="onListaPreciosChange"
        />
      </div>

      <!-- Actions Toolbar (slot reservado para que la tabla no se mueva al mostrar/ocultar) -->
      <div class="toolbar-slot">
        <v-slide-y-transition>
          <v-toolbar v-if="selected.length > 0" dense flat class="mb-1 actions-toolbar" color="grey lighten-4" height="42">
          <v-btn icon small color="grey darken-2" @click="clearSelection">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          
          <span class="subtitle-2 font-weight-medium ml-2 mr-3 actions-toolbar-text">
            {{ selected.length }} seleccionado{{ selected.length !== 1 ? 's' : '' }}
          </span>

          <v-tooltip bottom nudge-bottom="2" content-class="custom-tooltip" close-delay="0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="grey darken-2"
                v-bind="attrs"
                v-on="on"
                @click="$emit('createOferta', selected)"
                class="mr-1"
              >
                <v-icon>local_offer</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('producto.actions.createOferta') }}</span>
          </v-tooltip>

          <v-tooltip v-if="hasMultipleDepositos" bottom nudge-bottom="2" content-class="custom-tooltip" open-delay="200" close-delay="0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="grey darken-2"
                v-bind="attrs"
                v-on="on"
                @click="$emit('transferirStock', selected)"
                class="mr-1"
              >
                <v-icon>swap_horiz</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('producto.actions.transferirStock') }}</span>
          </v-tooltip>

          <v-tooltip bottom nudge-bottom="2" content-class="custom-tooltip" open-delay="200" close-delay="0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="grey darken-2"
                v-bind="attrs"
                v-on="on"
                @click="$emit('agregarStock', selected)"
                class="mr-1"
              >
                <v-icon>mdi-archive-plus</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('producto.actions.agregarStock') }}</span>
          </v-tooltip>

          <v-tooltip bottom nudge-bottom="2" content-class="custom-tooltip" open-delay="200" close-delay="0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="grey darken-2"
                v-bind="attrs"
                v-on="on"
                @click="$emit('cambioMasivoPrecio', selected)"
              >
                <v-icon>calculate</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('producto.actions.cambioMasivoPrecio') }}</span>
          </v-tooltip>

          <v-tooltip bottom nudge-bottom="2" content-class="custom-tooltip" open-delay="200" close-delay="0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="grey darken-2"
                v-bind="attrs"
                v-on="on"
                class="mr-1"
                @click="$emit('edicionMasivaAtributos', selected)"
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('producto.actions.edicionMasivaAtributos') }}</span>
          </v-tooltip>

          <v-tooltip bottom nudge-bottom="2" content-class="custom-tooltip" open-delay="200" close-delay="0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="grey darken-2"
                v-bind="attrs"
                v-on="on"
                class="mr-1"
                @click="exportSelectedToXlsx"
              >
                <v-icon>mdi-file-excel</v-icon>
              </v-btn>
            </template>
            <span>Exportar selección a Excel (.xlsx)</span>
          </v-tooltip>

          <v-tooltip
            v-if="puedeAddToPresupuestoPedido"
            bottom
            nudge-bottom="2"
            content-class="custom-tooltip"
            open-delay="200"
            close-delay="0"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="grey darken-2"
                v-bind="attrs"
                v-on="on"
                @click="$emit('addToPresupuestoPedido', selected)"
                class="mr-1"
              >
                <v-icon>mdi-file-document-plus</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('producto.actions.addToPresupuestoPedido') }}</span>
          </v-tooltip>

          <v-tooltip
            v-if="puedeAddToOrdenCompra"
            bottom
            nudge-bottom="2"
            content-class="custom-tooltip"
            open-delay="200"
            close-delay="0"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="grey darken-2"
                v-bind="attrs"
                v-on="on"
                @click="$emit('addToOrdenCompra', selected)"
                class="mr-1"
              >
                <v-icon>mdi-cart-arrow-down</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('producto.actions.addToOrdenCompra') }}</span>
          </v-tooltip>
        </v-toolbar>
        </v-slide-y-transition>
      </div>

      <!-- Edit Table Dialog (opened from pencil button in ProductoCrud) -->
      <v-dialog
        v-model="editTableDialogOpen"
        max-width="380"
        persistent
        content-class="edit-table-dialog"
      >
        <v-card class="edit-table-card">
          <div class="edit-table-header">
            <span class="edit-table-title">{{ $t('producto.actions.editarTabla') }}</span>
            <v-btn icon dark @click="editTableDialogOpen = false" class="edit-table-close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-list class="edit-table-list">
            <v-list-item
              v-for="col in toggleableColumns"
              :key="col.value"
              class="edit-table-item"
            >
              <v-list-item-content>
                <v-list-item-title>{{ col.text }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="mr-0">
                <v-btn
                  icon
                  small
                  @click="toggleColumnVisibility(col.value)"
                >
                  <v-icon :color="visibleColumnValues.includes(col.value) ? 'primary' : 'grey'">
                    {{ visibleColumnValues.includes(col.value) ? 'mdi-eye' : 'mdi-eye-off' }}
                  </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-dialog>

      <!-- Products Table -->
      <div class="producto-list-table-wrap">
      <v-data-table
        class="mt-1 producto-list-data-table"
        fixed-header
        :headers="visibleHeaders"
        :items="items"
        :search="search"
        :single-expand="false"
        :server-items-length="totalItems"
        :loading="loading"
        :page.sync="pageNumber"
        :items-per-page.sync="itemsPerPage"
        :sort-by.sync="orderBy"
        :sort-desc.sync="orderDesc"
        :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50, 100] }"
        height="calc(100vh - 260px)"
        show-select
        v-model="selected"
        @update:page="fetch"
        @update:sort-by="fetch"
        @update:sort-desc="fetch"
        @update:items-per-page="fetch"
      >
        <template v-slot:item.nombre="{ item }">
          {{ item.nombre || '-' }}
        </template>

        <template v-slot:item.marca="{ item }">
          {{ (item.marca && item.marca.nombre != null && String(item.marca.nombre).trim()) || '-' }}
        </template>

        <template v-slot:item.modelo="{ item }">
          {{ (item.modelo && item.modelo.nombre != null && String(item.modelo.nombre).trim()) || '-' }}
        </template>

        <template v-slot:item.tamanio="{ item }">
          {{ (item.tamanio && item.tamanio.tamanio != null && String(item.tamanio.tamanio).trim()) || '-' }}
        </template>

        <template v-slot:item.otrasCaracteristicas="{ item }">
          {{ (item.otrasCaracteristicas != null && String(item.otrasCaracteristicas).trim()) || '-' }}
        </template>

        <template v-slot:item.proveedor="{ item }">
          {{
            (item.productoProveedorPrecioActivo &&
              item.productoProveedorPrecioActivo.proveedor &&
              item.productoProveedorPrecioActivo.proveedor.nombre) ||
            '-'
          }}
        </template>

        <template v-slot:item.almacenes="{ item }">
          {{
            item.almacenes && item.almacenes.length
              ? item.almacenes.map((a) => (a && a.nombre) || '').filter(Boolean).join(', ') || '-'
              : '-'
          }}
        </template>

        <template v-slot:item.creadoPor="{ item }">
          {{ item.creadoPor.username }}
        </template>

        <template v-slot:item.precioCompra="{ item }">
          $ {{ item.precioCompra ? item.precioCompra.toFixed(2) : '0.00' }}
        </template>

        <template v-slot:item.precio="{ item }">
          $ {{ item.precio ? item.precio.toFixed(2) : '0.00' }}
        </template>

        <template v-slot:item.stock="{ item }">
          <v-chip :color="getColor(item)" dark>
            {{ item.stock }}
          </v-chip>
        </template>

        <template v-slot:item.fechaVencimiento="{ item }">
          {{ item.fechaVencimiento ? getDateTimeFormat(item.fechaVencimiento) : '-' }}
        </template>

        <template v-slot:item.createdAt="{ item }">
          {{ getDateTimeFormat(item.createdAt) }}
        </template>

        <template v-slot:item.updatedAt="{ item }">
          {{ getDateTimeFormat(item.updatedAt) }}
        </template>

        <template slot="no-data">
          <div class="text-xs-center" v-t="'common.noData'"></div>
        </template>

        <template slot="loading">
          <div class="text-xs-center" v-t="'common.loading'"></div>
        </template>

        <template v-slot:item.action="{ item }">
          <div class="table-actions-cell">
            <show-button @click="$emit('show', item)" />
            <edit-button @click="$emit('update', item)" />
            <delete-button @click="$emit('delete', item)" />
          </div>
        </template>
      </v-data-table>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import ProductoProvider from "../../../providers/ProductoProvider";
import ProductoFilters from "../ProductoFilters";
import UserConfigurationProvider from "../../../../user-configuration/providers/UserConfigurationProvider";
import DepositoProvider from "../../../../deposito/providers/DepositoProvider";
import ListaPreciosVentaProvider from "../../../../lista-precios-venta/providers/ListaPreciosVentaProvider";
import { EditButton, ShowButton, DeleteButton } from "@dracul/common-frontend";
import { DayjsMixin } from "@dracul/dayjs-frontend";
import * as XLSX from "xlsx";

export default {
  name: "ProductoList",
  components: {
    EditButton,
    ShowButton,
    ProductoFilters,
    DeleteButton,
  },
  mixins: [DayjsMixin],
  data() {
    return {
      items: [],
      totalItems: null,
      loading: false,
      orderBy: "updatedAt",
      orderDesc: true,
      itemsPerPage: 50,
      pageNumber: 1,
      search: "",
      stock: null,
      stockAlerta: null,
      selected: [],
      userDepositosCount: 0,
      userDepositos: [],
      depositoIdSeleccionado: null,
      visibleColumnValues: [],
      editTableDialogOpen: false,
      listasPrecios: [],
      listaPreciosId: null,
      filters: [
        {
          field: "nombre",
          operator: "$regex",
          value: null,
        },
        {
          field: "marca.nombre",
          operator: "$regex",
          value: null,
        },
        {
          field: "modelo.nombre",
          operator: "$regex",
          value: null,
        },
        {
          field: "tamanio.tamanio",
          operator: "$regex",
          value: null,
        },
        {
          field: "codigoBarras",
          operator: "$regex",
          value: null,
        },
        {
          field: "stockAlerta",
          operator: "$regex",
          value: null,
        },
        {
          field: "fechaVencimiento",
          operator: "$lte",
          value: null,
        },
        {
          field: "stock",
          operator: "$gt",
          value: null,
        },
        {
          field: "precio",
          operator: "$lt",
          value: null,
        },
        {
          field: "proveedorId",
          operator: "$eq",
          value: null,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["me"]),
    rolePermissions() {
      return (this.me && this.me.role && this.me.role.permissions) || [];
    },
    puedeAddToPresupuestoPedido() {
      return Array.isArray(this.rolePermissions) && this.rolePermissions.includes("VENTAS_ORDEN_CREATE");
    },
    puedeAddToOrdenCompra() {
      return Array.isArray(this.rolePermissions) && this.rolePermissions.includes("COMPRAS_ORDEN_CREATE");
    },
    allHeaders() {
      const entity = [
        { text: this.$t("producto.labels.nombre"), value: "nombre" },
        { text: this.$t("producto.labels.marca"), value: "marca" },
        { text: this.$t("producto.labels.modelo"), value: "modelo" },
        { text: this.$t("producto.labels.tamanio"), value: "tamanio" },
        { text: this.$t("producto.labels.otrasCaracteristicas"), value: "otrasCaracteristicas" },
      ];
      return [
        ...entity,
        { text: this.$t("producto.labels.precioCompra"), value: "precioCompra" },
        { text: this.$t("producto.labels.precioVenta"), value: "precio" },
        { text: this.$t("producto.labels.stock"), value: "stock" },
        { text: this.$t("producto.labels.fechaVencimiento"), value: "fechaVencimiento" },
        {
          text: this.$t("producto.labels.codigoBarras"),
          value: "codigoBarras",
        },
        { text: this.$t("producto.labels.proveedor"), value: "proveedor", sortable: false },
        {
          text: this.$t("producto.labels.almacen"),
          value: "almacenes",
          sortable: false,
        },
        {
          text: this.$t("producto.labels.fechaUltimaModificacion"),
          value: "updatedAt",
        },
        {
          text: this.$t("producto.labels.fechaCreacion"),
          value: "createdAt",
        },
        { text: this.$t("producto.labels.creadoPor"), value: "creadoPor" },
        //Actions
        {
          text: this.$t("common.actions"),
          value: "action",
          sortable: false,
          width: 140,
          cellClass: "cell-actions",
          class: "cell-actions",
        },
      ];
    },
    toggleableColumns() {
      return this.allHeaders.filter((h) => h.value !== "action");
    },
    visibleHeaders() {
      return this.allHeaders.filter(
        (h) => h.value === "action" || this.visibleColumnValues.includes(h.value)
      );
    },
    getOrderBy() {
      return Array.isArray(this.orderBy) ? this.orderBy[0] : this.orderBy;
    },
    getOrderDesc() {
      return Array.isArray(this.orderDesc) ? this.orderDesc[0] : this.orderDesc;
    },
    hasMultipleDepositos() {
      return this.userDepositosCount > 1;
    },
    showListaPreciosSelector() {
      return this.listasPrecios.length > 1;
    },
  },
  watch: {
    visibleColumnValues() {
      this.validateOrderByForVisibleColumns();
    },
    hasMultipleDepositos(val) {
      if (val && !this.visibleColumnValues.includes('almacenes')) {
        this.visibleColumnValues = [...this.visibleColumnValues, 'almacenes'];
        this.saveVisibleColumnsToStorage();
      }
    },
  },
  async created() {
    this.initVisibleColumns();
    await this.updateDepositoFilter();
    await this.loadUserDepositos();
    await this.loadListasPrecios();
    this.fetch();
  },
  mounted() {
    // Escuchar eventos de actualización de configuración
    this.$root.$on('userConfigurationUpdated', async () => {
      await this.updateDepositoFilter();
      await this.loadUserDepositos();
      this.fetch();
    });
  },
  beforeDestroy() {
    this.$root.$off('userConfigurationUpdated');
  },
  methods: {
    async loadUserDepositos() {
      try {
        const response = await UserConfigurationProvider.getUserConfiguration(false);
        if (response && response.data && response.data.userConfigurationGet) {
          const config = response.data.userConfigurationGet;
          const depositoIds = config.depositoIds || [];
          this.userDepositosCount = depositoIds.length;
          this.depositoIdSeleccionado = config.depositoIdSeleccionado || null;
          if (config.depositos && config.depositos.length === depositoIds.length) {
            this.userDepositos = config.depositos.map(d => ({ id: String(d.id), nombre: d.nombre || '' }));
          } else if (depositoIds.length > 0) {
            const depositosResponse = await DepositoProvider.fetchDepositos();
            const todosDepositos = (depositosResponse?.data?.depositoFetch) || [];
            const depositoIdsStr = depositoIds.map(id => String(id));
            this.userDepositos = todosDepositos
              .filter(d => depositoIdsStr.includes(String(d.id)))
              .map(d => ({ id: String(d.id), nombre: d.nombre || '' }));
          } else if (config.deposito && config.deposito) {
            this.userDepositos = [{ id: String(config.deposito.id), nombre: config.deposito.nombre || '' }];
          } else {
            this.userDepositos = [];
          }
        }
      } catch (error) {
        console.error('Error loading user depositos:', error);
        this.userDepositosCount = 0;
        this.userDepositos = [];
        this.depositoIdSeleccionado = null;
      }
    },
    async updateDepositoFilter() {
      // Si viene de importación, priorizar el depositoId del query
      let depositoId = this.$route?.query?.depositoId || null;
      
      if (!depositoId) {
        depositoId = UserConfigurationProvider.getDepositoIdFromCache();
      }
      
      // Si no está en el cache, intentar cargar la configuración del usuario
      if (!depositoId) {
        try {
          const response = await UserConfigurationProvider.getUserConfiguration(false);
          if (response && response.data && response.data.userConfigurationGet) {
            depositoId = response.data.userConfigurationGet.depositoIdSeleccionado;
          }
        } catch (error) {
          // Si falla, intentar con network-only
          try {
            const response = await UserConfigurationProvider.getUserConfiguration(true);
            if (response && response.data && response.data.userConfigurationGet) {
              depositoId = response.data.userConfigurationGet.depositoIdSeleccionado;
            }
          } catch (err) {
            console.error('Error loading user configuration:', err);
          }
        }
      }
      
      if (depositoId) {
        this.depositoIdSeleccionado = depositoId;
      }

      // Buscar o crear el filtro de deposito
      let depositoFilterIndex = this.filters.findIndex(f => f.field === 'deposito' || f.field === 'depositoId');

      if (depositoId) {
        if (depositoFilterIndex >= 0) {
          // Actualizar el filtro existente
          this.filters[depositoFilterIndex].value = depositoId;
          this.filters[depositoFilterIndex].operator = '$eq';
          this.filters[depositoFilterIndex].field = 'deposito';
        } else {
          // Agregar nuevo filtro
          this.filters.push({
            field: 'deposito',
            operator: '$eq',
            value: depositoId
          });
        }
      } else {
        // Si no hay depositoId, remover el valor del filtro si existe
        if (depositoFilterIndex >= 0) {
          this.filters[depositoFilterIndex].value = null;
        }
      }
    },
    updateItems(updatedProductos) {
      this.$emit('onItemUpdated', updatedProductos);
    },
    performSearch() {
      this.pageNumber = 1;
      this.fetch();
    },
    async loadListasPrecios() {
      try {
        const r = await ListaPreciosVentaProvider.list();
        this.listasPrecios = (r && r.data && r.data.listaPreciosVentaList) || [];
        if (this.listasPrecios.length === 1) {
          this.listaPreciosId = this.listasPrecios[0].id;
        } else if (!this.listaPreciosId) {
          const def = this.listasPrecios.find((l) => l.isDefault);
          const selected = def || this.listasPrecios[0];
          if (selected) this.listaPreciosId = selected.id;
        }
      } catch (e) {
        this.listasPrecios = [];
      }
    },
    onListaPreciosChange() {
      if (!this.listaPreciosId && this.listasPrecios.length > 0) {
        const def = this.listasPrecios.find((l) => l.isDefault);
        const selected = def || this.listasPrecios[0];
        this.listaPreciosId = selected.id;
      }
      this.pageNumber = 1;
      this.fetch();
    },
    async fetch() {
      this.loading = true;
      ProductoProvider.paginateProductos(
        this.pageNumber,
        this.itemsPerPage,
        this.search,
        this.filters,
        this.getOrderBy,
        this.getOrderDesc,
        this.listaPreciosId || null
      )
        .then((r) => {
          this.items = r.data.productoPaginate.items;
          this.totalItems = r.data.productoPaginate.totalItems;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => (this.loading = false));
    },
    getColor(item) {
      if (item.stock > item.stockAlerta) {
        return "green";
      } else if (item.stock >= 1 && item.stock <= item.stockAlerta) {
        return "yellow darken-3";
      } else {
        return "red";
      }
    },
    async setFilters(filters) {
      this.pageNumber = 1;
      // Validate and convert numeric values to strings for GraphQL
      filters.forEach(filter => {
        if ((filter.field === 'stock' || filter.field === 'precio') && filter.value !== null) {
          const numValue = Number(filter.value);
          if (isNaN(numValue) || numValue < 0) {
            filter.value = null;
          } else {
            // Convert to string for GraphQL (FilterInput expects String)
            filter.value = String(numValue);
          }
        }
      });
      
      this.filters = filters;
      this.fetch();
    },
    async clearFilters() {
      this.pageNumber = 1;
      this.filters.forEach((filter) => {
        // No limpiar el filtro de depósito
        if (filter.field !== 'deposito' && filter.field !== 'depositoId') {
          filter.value = null;
          // Reset operators to defaults
          if (filter.field === 'stock') {
            filter.operator = '$gt';
          } else if (filter.field === 'precio') {
            filter.operator = '$lt';
          }
        }
      });
      // Asegurar que el filtro de depósito siempre esté presente
      await this.updateDepositoFilter();
      this.fetch();
    },
    clearSelection() {
      this.selected = [];
    },
    exportCellValue(item, colValue) {
      if (!item) return "";
      switch (colValue) {
        case "nombre":
          return item.nombre || "";
        case "marca":
          return (item.marca && item.marca.nombre) || "";
        case "modelo":
          return (item.modelo && item.modelo.nombre) || "";
        case "tamanio":
          return (item.tamanio && item.tamanio.tamanio) || "";
        case "otrasCaracteristicas":
          return item.otrasCaracteristicas != null ? String(item.otrasCaracteristicas) : "";
        case "almacenes":
          return item.almacenes && item.almacenes.length
            ? item.almacenes.map((a) => (a && a.nombre) || "").filter(Boolean).join(", ")
            : "";
        case "precioCompra":
          return item.precioCompra != null ? Number(item.precioCompra) : "";
        case "precio":
          return item.precio != null ? Number(item.precio) : "";
        case "stock":
          return item.stock != null ? Number(item.stock) : "";
        case "fechaVencimiento":
          return item.fechaVencimiento ? this.getDateTimeFormat(item.fechaVencimiento) : "";
        case "codigoBarras":
          return item.codigoBarras || "";
        case "proveedor":
          return (
            (item.productoProveedorPrecioActivo &&
              item.productoProveedorPrecioActivo.proveedor &&
              item.productoProveedorPrecioActivo.proveedor.nombre) ||
            ""
          );
        case "updatedAt":
          return item.updatedAt ? this.getDateTimeFormat(item.updatedAt) : "";
        case "createdAt":
          return item.createdAt ? this.getDateTimeFormat(item.createdAt) : "";
        case "creadoPor":
          return (item.creadoPor && item.creadoPor.username) || "";
        default:
          return item[colValue] != null ? String(item[colValue]) : "";
      }
    },
    exportSelectedToXlsx() {
      const sel = this.selected || [];
      if (!sel.length) return;
      const cols = this.allHeaders.filter((h) => h.value !== "action");
      const headerRow = cols.map((c) => c.text);
      const dataRows = sel.map((item) => cols.map((c) => this.exportCellValue(item, c.value)));
      const ws = XLSX.utils.aoa_to_sheet([headerRow, ...dataRows]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Productos");
      const name = `productos_seleccionados_${new Date().toISOString().slice(0, 10)}.xlsx`;
      XLSX.writeFile(wb, name);
    },
    openEditTableDialog() {
      this.editTableDialogOpen = true;
    },
    initVisibleColumns() {
      const STORAGE_KEY = "productoListVisibleColumns";
      const validValues = [
        "nombre",
        "marca",
        "modelo",
        "tamanio",
        "otrasCaracteristicas",
        "almacenes",
        "precioCompra",
        "precio",
        "stock",
        "fechaVencimiento",
        "codigoBarras",
        "proveedor",
        "updatedAt",
        "createdAt",
        "creadoPor",
      ];
      try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
          const parsed = JSON.parse(stored);
          const migrated = parsed.map((v) => (v === "almacen" ? "almacenes" : v));
          const filtered = [...new Set(migrated)].filter((v) => validValues.includes(v));
          if (filtered.length > 0) {
            this.visibleColumnValues = filtered;
            return;
          }
        }
      } catch (e) {
        // ignore invalid stored data
      }
      this.visibleColumnValues = [...validValues];
      this.saveVisibleColumnsToStorage();
    },
    saveVisibleColumnsToStorage() {
      try {
        localStorage.setItem(
          "productoListVisibleColumns",
          JSON.stringify(this.visibleColumnValues)
        );
      } catch (e) {
        // ignore
      }
    },
    toggleColumnVisibility(value) {
      const isVisible = this.visibleColumnValues.includes(value);
      if (isVisible && this.visibleColumnValues.length <= 1) return;
      if (isVisible) {
        this.visibleColumnValues = this.visibleColumnValues.filter((v) => v !== value);
      } else {
        this.visibleColumnValues = [...this.visibleColumnValues, value];
      }
      this.saveVisibleColumnsToStorage();
    },
    selectAllColumns() {
      this.visibleColumnValues = this.toggleableColumns.map((c) => c.value);
      this.saveVisibleColumnsToStorage();
    },
    clearColumns() {
      this.visibleColumnValues = this.toggleableColumns.length > 0
        ? [this.toggleableColumns[0].value]
        : [];
      this.saveVisibleColumnsToStorage();
    },
    validateOrderByForVisibleColumns() {
      const orderByValue = this.getOrderBy;
      if (
        orderByValue &&
        orderByValue !== "action" &&
        !this.visibleColumnValues.includes(orderByValue)
      ) {
        const firstVisible =
          this.visibleColumnValues[0] || this.toggleableColumns[0]?.value || "updatedAt";
        this.orderBy = firstVisible;
        this.fetch();
      }
    },
    addItemToCsv(item) {
      const form = item;
      ProductoProvider.addProductoToCsv(form)
        .then(() => {
          this.$emit("addProductoToCsv", form);
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style scoped>
.producto-list-table-wrap {
  min-height: 0;
}

/* Reserva espacio fijo para la toolbar de acciones (42px toolbar + 4px mb-1) */
.toolbar-slot {
  min-height: 46px;
}

.actions-toolbar {
  border-radius: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
}

.lista-precios-row {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 4px;
  padding: 0 8px;
}

.lista-precios-row .v-select {
  max-width: 260px;
}

/* Gris oscuro solo para íconos de esta barra (sobreescribe estilos globales del toolbar) */
::v-deep .actions-toolbar.v-toolbar .v-btn .v-icon,
::v-deep .actions-toolbar.v-toolbar .v-btn--icon .v-icon {
  color: #424242 !important;
}

::v-deep .actions-toolbar span {
  color: #424242 !important;
}

</style>

<style>
/* Edit Table Dialog - blue header like reference image */
.edit-table-dialog .v-dialog {
  border-radius: 8px;
  overflow: hidden;
}

.edit-table-card {
  overflow: hidden;
}

.edit-table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #1976d2;
  color: white;
  font-size: 1rem;
  font-weight: 600;
}

.edit-table-title {
  color: white;
}

.edit-table-close {
  color: white !important;
}

.edit-table-close .v-icon {
  color: white !important;
}

.edit-table-list {
  max-height: 400px;
  overflow-y: auto;
}

.edit-table-item {
  border-bottom: 1px solid #eee;
}

.edit-table-item:last-child {
  border-bottom: none;
}
</style>

<style>
.custom-tooltip {
  background-color: #424242 !important;
  opacity: 1 !important;
}

.custom-tooltip span {
  color: white !important;
}
</style>
